export default __webpack_public_path__ + "static/media/kanit-light.9d1f3e81.eot";